import React from 'react';
import { supabase } from '../../services/supabaseClient';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Welcome.css';

const WelcomePage = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const handleStartSetup = async () => {
//    const { error } = await supabase.auth.updateUser({
//      data: { isSetupComplete: true },
//    });

//    if (error) {
//      console.error('❌ Failed to update isSetupComplete:', error.message);
//      return;
//    }

    // ✅ Update local context — ProtectedRoute will handle redirect
//    if (setUser && user) {
//      setUser({
//        ...user,
//        isSetupComplete: true,
//      });
//    }

//    console.log('✅ isSetupComplete set in auth and context');
    navigate('/accountsetup');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Welcome to Comverex.ai!</h2>
        <p style={{ marginBottom: '30px', textAlign: 'center' }}>
          <b>We're excited to have you!</b><br /><br />
        </p>
        <button className="auth-button" onClick={handleStartSetup}>
          Let's Set Up Your Account
        </button>
      </div>
    </div>
  );
};

export default WelcomePage;
